import React from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);

const ItemMap = [
	{
		icon: 'https://web-data.zmlearn.com/image/2BdcvWjBMYPT6zxUUq6N84/27%402x.png',
		title: 'Free trial session',
		desc: "we don't charge anything at the first session!",
	},
	{
		icon: 'https://web-data.zmlearn.com/image/vCCkXnLiUARcZYLhPiAF4S/28%402x.png',
		title: 'Flexible schedule',
		desc: 'you can schedule or cancel a class at your will!',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/jezKwbcjymFLSjC9v81PK8/29%402x.png',
		title: 'Replace tutor for free',
		desc: 'you can replace a new tutor smoothly if you are not happy with the current one.',
	},
	{
		icon: 'https://web-data.zmlearn.com/image/hG4kzTEU88swfJnwb5zMyU/30%402x.png',
		title: 'Hassle-free refund',
		desc: 'Free refund within 14 days if you are disatisfied with the lessons.',
	},
];
/**
 * Trait
 * @returns
 */
export default function TraitBox() {
	return (
		<div className={cx('trait-box')}>
			<Section>
				<h3 className={cx('block-title', 'black')}>Flexibility. Quality. Warranty.</h3>
				<div className={cx('items', 'scroll-view')}>
					{ItemMap.map((item, idx) => {
						return (
							<div key={idx} className={cx('item')}>
								<img loading="lazy" className={cx('img')} src={item.icon} alt={item.title} />
								<h5>{item.title}</h5>
								<p>{item.desc}</p>
							</div>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
